import React from 'react';
import PropTypes from 'prop-types';

import styles from './ListGroup.scss';

class ListGroup extends React.PureComponent {
  render() {
    const { groupType, sidebar, children, size } = this.props;

    return (
      <div
        className={`ListGroup  ListGroup--${groupType}${
          sidebar ? ' ListGroup--with-sidebar' : ''
        } ListGroup--size-${size}`}
      >
        <div className="ListGroup__container">
          {sidebar ? <div className="ListGroup__sidebar">{sidebar}</div> : null}
          <div className="ListGroup__list">{children}</div>
        </div>
      </div>
    );
  }
}

ListGroup.propTypes = {
  groupType: PropTypes.oneOf(['school', 'stats', 'class']),
  size: PropTypes.oneOf(['wide', 'normal']),
  sidebar: PropTypes.element,
  children: PropTypes.node,
};

ListGroup.defaultProps = {
  size: 'normal',
};

export default ListGroup;
